import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { hexagramBits } from '../../core/iching-core';
import { ICHING_HEXAGRAM_MATRIX, ICHING_TRIGRAM_TABLE_ORDER, ICHING_TRIGRAMS } from '../../core/iching-trigrams.const';
import { IChingFigure, IChingTrigramFacts } from '../../core/iching.models';
import { HdIChingHexagramFigureComponent } from '../../figure/hd-iching-hexagram-figure.component';
import { injectIChingTranslate } from '../iching-consult-translate';

interface MatrixCell {
  readonly number: number;
  readonly figure: IChingFigure;
}

interface MatrixRow {
  readonly upper: IChingTrigramFacts;
  readonly cells: readonly MatrixCell[];
}

const COLUMNS: readonly IChingTrigramFacts[] = ICHING_TRIGRAM_TABLE_ORDER.map(id => ICHING_TRIGRAMS[id]);

/** Wilhelms sleuteltabel: rij = boventrigram, kolom = ondertrigram. Statisch, dus eenmalig opgebouwd. */
const ROWS: readonly MatrixRow[] = ICHING_HEXAGRAM_MATRIX.map((numbers, rowIndex) => ({
  upper: COLUMNS[rowIndex],
  cells: numbers.map(number => ({ number, figure: hexagramBits(number) })),
}));

/**
 * 8×8-sleuteltabel om een hexagram rechtstreeks te kiezen: elke knop toont
 * mini-figuur en nummer; rij- en kolomkoppen tonen de trigramsymbolen.
 */
@Component({
  selector: 'hd-iching-hexagram-matrix',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HdIChingHexagramFigureComponent],
  templateUrl: './hd-iching-hexagram-matrix.component.html',
  styleUrl: './hd-iching-hexagram-matrix.component.scss',
})
export class HdIChingHexagramMatrixComponent {
  readonly selected = input<number | undefined>(undefined);
  readonly hexagramSelected = output<number>();

  protected readonly t = injectIChingTranslate();
  protected readonly columns = COLUMNS;
  protected readonly rows = ROWS;
}
